import request from '../../utils/requests'

/**
 * Tag: OrgStatistics
 */

const baseUrl = '/api/OrgStatistics';

/**
 * 校区应收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForBranchExport (body) {
  return request(baseUrl + '/getStatisticsShouldForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 经办人应收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForUser (body) {
  return request(baseUrl + '/getStatisticsShouldForUser', {
    method: 'POST',
    body: body
  });
}

/**
 * 经办人应收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForUserExport (body) {
  return request(baseUrl + '/getStatisticsShouldForUserExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 支付方式应收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForPaySense (body) {
  return request(baseUrl + '/getStatisticsShouldForPaySense', {
    method: 'POST',
    body: body
  });
}

/**
 * 支付方式应收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForPaySenseExport (body) {
  return request(baseUrl + '/getStatisticsShouldForPaySenseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程应收计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForCourse (body) {
  return request(baseUrl + '/getStatisticsShouldForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程应收计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForCourseExport (body) {
  return request(baseUrl + '/getStatisticsShouldForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型应收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForCourseType (body) {
  return request(baseUrl + '/getStatisticsShouldForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型应收计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsShouldForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 投保份数统计（日期）
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    BranchId Desc:校区 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 * }
 */
async function _getStatisticsInsuranceCount (body) {
  return request(baseUrl + '/getStatisticsInsuranceCount', {
    method: 'POST',
    body: body
  });
}

/**
 * 实收金额统计（日期）
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    BranchId Desc:校区 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 * }
 */
async function _getStatisticsRealIncomeAmount (body) {
  return request(baseUrl + '/getStatisticsRealIncomeAmount', {
    method: 'POST',
    body: body
  });
}

/**
 * 课消收入统计（日期）
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    BranchId Desc:校区 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 * }
 */
async function _getStatisticsDeductPrice (body) {
  return request(baseUrl + '/getStatisticsDeductPrice', {
    method: 'POST',
    body: body
  });
}

/**
 * 首页经营数据总数统计（日期）
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    BranchId Desc:校区 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 * }
 */
async function _getTotalForHomePage (body) {
  return request(baseUrl + '/getTotalForHomePage', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区业绩榜
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 *    SortType Desc:0 客户新增数量 1 销售金额 2 销售单量 Required:false
 * }
 */
async function _getStatisticsSalesForBranch (body) {
  return request(baseUrl + '/getStatisticsSalesForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售业绩榜
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 *    SortType Desc:1 销售金额 2 销售单量 Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesForSeller (body) {
  return request(baseUrl + '/getStatisticsSalesForSeller', {
    method: 'POST',
    body: body
  });
}

/**
 * 新增客户
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesForCustomerAdded (body) {
  return request(baseUrl + '/getStatisticsSalesForCustomerAdded', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售漏斗
 * @param {*} param
 * {
 *    branchId Desc:0 全部校区 ; &gt;0 校区 Required:true
 * }
 */
async function _getStatisticsSalesForSalesFunnel (param) {
  return request(baseUrl + '/getStatisticsSalesForSalesFunnel', {
    method: 'POST',
    params: param
  });
}

/**
 * 销售漏斗详情校区
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesFunnelDetailForBranch (body) {
  return request(baseUrl + '/getStatisticsSalesFunnelDetailForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售漏斗详情校区 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesFunnelDetailForBranchExport (body) {
  return request(baseUrl + '/getStatisticsSalesFunnelDetailForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售漏斗详情 跟进人
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgUserId Desc:跟进人 Required:false
 * }
 */
async function _getStatisticsSalesFunnelDetailForFollowUp (body) {
  return request(baseUrl + '/getStatisticsSalesFunnelDetailForFollowUp', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售漏斗详情 跟进人 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 *    OrgUserId Desc:跟进人 Required:false
 * }
 */
async function _getStatisticsSalesFunnelDetailForFollowUpExport (body) {
  return request(baseUrl + '/getStatisticsSalesFunnelDetailForFollowUpExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户占比 来源
 * @param {*} param
 * {
 *    branchId Desc:0 全部 ; &gt;0 特定校区 Required:true
 * }
 */
async function _getStatisticsSalesEntryChannelBranch (param) {
  return request(baseUrl + '/getStatisticsSalesEntryChannelBranch', {
    method: 'POST',
    params: param
  });
}

/**
 * 客户占比 性别
 * @param {*} param
 * {
 *    branchId Desc:0 全部 ; &gt;0 特定校区 Required:true
 * }
 */
async function _getStatisticsSalesEntryChannelGender (param) {
  return request(baseUrl + '/getStatisticsSalesEntryChannelGender', {
    method: 'POST',
    params: param
  });
}

/**
 * 客户来源详情 跟进人
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 *    FollowUpId Desc:跟进人 Required:false
 * }
 */
async function _getStatisticsSalesProportionDetailForFollowUp (body) {
  return request(baseUrl + '/getStatisticsSalesProportionDetailForFollowUp', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户来源详情 跟进人 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 *    FollowUpId Desc:跟进人 Required:false
 * }
 */
async function _getStatisticsSalesProportionDetailForFollowUpExport (body) {
  return request(baseUrl + '/getStatisticsSalesProportionDetailForFollowUpExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户来源详情 机构
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesProportionDetailForBranch (body) {
  return request(baseUrl + '/getStatisticsSalesProportionDetailForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户来源详情 机构 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesProportionDetailForBranchExport (body) {
  return request(baseUrl + '/getStatisticsSalesProportionDetailForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户性别详情 机构
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesGenderDetailForBranch (body) {
  return request(baseUrl + '/getStatisticsSalesGenderDetailForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户性别详情 校区
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesGenderDetailForBranchExport (body) {
  return request(baseUrl + '/getStatisticsSalesGenderDetailForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户性别详情 跟进人 校区
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Id Required:false
 *    FollowUpId Desc:跟进人Id Required:false
 * }
 */
async function _getStatisticsSalesGenderDetailForFollowUp (body) {
  return request(baseUrl + '/getStatisticsSalesGenderDetailForFollowUp', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户性别详情 跟进人 校区导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Id Required:false
 *    FollowUpId Desc:跟进人Id Required:false
 * }
 */
async function _getStatisticsSalesGenderDetailForFollowUpExport (body) {
  return request(baseUrl + '/getStatisticsSalesGenderDetailForFollowUpExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售数据统计
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsSalesForOrder (body) {
  return request(baseUrl + '/getStatisticsSalesForOrder', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情  销售金额/销售单量 图表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForAmountA (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForAmountA', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情  销售金额/销售单量 图表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForALL (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForALL', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情  销售金额/销售单量 列表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForAmountB (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForAmountB', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情-列表 销售金额/销售单量导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailExport (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情  销售金额/销售单量 图表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    FollowUpId Desc:跟进人 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForAmountBranchA (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForAmountBranchA', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情  销售金额/销售单量 列表
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    FollowUpId Desc:跟进人 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForAmountBranchB (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForAmountBranchB', {
    method: 'POST',
    body: body
  });
}

/**
 * 销售详情-列表 销售金额/销售单量导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    DateStart Desc:开始时间 Required:false
 *    DateEnd Desc:结束时间 Required:true
 *    BranchId Desc:校区 Required:false
 *    FollowUpId Desc:跟进人 Required:false
 *    ShowType Desc:导出使用 true金额 false数量 Required:false
 * }
 */
async function _getStatisticsSalesOrderDetailForAmountBranchBExport (body) {
  return request(baseUrl + '/getStatisticsSalesOrderDetailForAmountBranchBExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 授课课时
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 4:今日 5:昨日 6:本周 7:本月 8：一个月 999：自定义 Required:false
 *    StartDate Desc:自定义：开始时间(Type=999时使用) Required:false
 *    EndDate Desc:自定义：结束时间(Type=999时使用) Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsClassCount (body) {
  return request(baseUrl + '/getStatisticsClassCount', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区授课课时统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForBranch (body) {
  return request(baseUrl + '/getStatisticsClassCountForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区授课课时统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForBranchExport (body) {
  return request(baseUrl + '/getStatisticsClassCountForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程授课课时统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForCourse (body) {
  return request(baseUrl + '/getStatisticsClassCountForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程授课课时统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForCourseExport (body) {
  return request(baseUrl + '/getStatisticsClassCountForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型授课课时统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForCourseType (body) {
  return request(baseUrl + '/getStatisticsClassCountForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型授课课时统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsClassCountForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 签到老师授课课时统计查询:共享
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForTeacherShare (body) {
  return request(baseUrl + '/getStatisticsClassCountForTeacherShare', {
    method: 'POST',
    body: body
  });
}

/**
 * 签到老师授课课时统计导出:共享
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForTeacherShareExport (body) {
  return request(baseUrl + '/getStatisticsClassCountForTeacherShareExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师授课课时统计查询:平分
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForTeacherDeuce (body) {
  return request(baseUrl + '/getStatisticsClassCountForTeacherDeuce', {
    method: 'POST',
    body: body
  });
}

/**
 * 签到老师授课课时统计导出:平分
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsClassCountForTeacherDeuceExport (body) {
  return request(baseUrl + '/getStatisticsClassCountForTeacherDeuceExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤统计
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsStudentAttendance (body) {
  return request(baseUrl + '/getStatisticsStudentAttendance', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 校区
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForBranch (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 校区 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForBranchExport (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 老师
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForTeacher (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForTeacher', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 校区 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForTeacherExport (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForTeacherExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 课程
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForCourse (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 课程 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForCourseExport (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 课程
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForCourseType (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 学员出勤详情 课程 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsStudentAttendanceForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsStudentAttendanceForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤统计
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    Type Desc:1 ：7天 2：15天 3:6个月 Required:false
 *    BranchId Desc:校区 Required:false
 * }
 */
async function _getStatisticsTeacherAttendance (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendance', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 校区
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForBranch (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 校区 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForBranchExport (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 老师
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForTeacher (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForTeacher', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 老师 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForTeacherExport (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForTeacherExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 课程
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForCourse (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 课程 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForCourseExport (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 课程类型
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForCourseType (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师出勤 课程类型 导出
 * @param {*} body
 * {
 *    OrgId Desc:机构Id Required:false
 *    BranchId Desc:校区Ids Required:false
 *    DateStart Desc:开始时间 Required:true
 *    DateEnd Desc:结束时间 Required:true
 * }
 */
async function _getStatisticsTeacherAttendanceForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsTeacherAttendanceForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForBranch (body) {
  return request(baseUrl + '/getStatisticsDeductedForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForBranchExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForCourse (body) {
  return request(baseUrl + '/getStatisticsDeductedForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForCourseExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForCourseType (body) {
  return request(baseUrl + '/getStatisticsDeductedForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForTeachers (body) {
  return request(baseUrl + '/getStatisticsDeductedForTeachers', {
    method: 'POST',
    body: body
  });
}

/**
 * 老师课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForTeachersExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForTeachersExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 助教课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForAssistants (body) {
  return request(baseUrl + '/getStatisticsDeductedForAssistants', {
    method: 'POST',
    body: body
  });
}

/**
 * 助教课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForAssistantsExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForAssistantsExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 场地课消统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForSite (body) {
  return request(baseUrl + '/getStatisticsDeductedForSite', {
    method: 'POST',
    body: body
  });
}

/**
 * 场地课消统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedForSiteExport (body) {
  return request(baseUrl + '/getStatisticsDeductedForSiteExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 明细课消统计查询
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    OrgSiteId Desc:助教Id Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDeducted Desc:是否为课消，导出时使用（true:课消，false:授课课时） Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedDetail (body) {
  return request(baseUrl + '/getStatisticsDeductedDetail', {
    method: 'POST',
    body: body
  });
}

/**
 * 明细课消统计导出
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    OrgSiteId Desc:助教Id Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDeducted Desc:是否为课消，导出时使用（true:课消，false:授课课时） Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedDetailExport (body) {
  return request(baseUrl + '/getStatisticsDeductedDetailExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课消明细分页查询
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    ClassId Desc:班级主键Id Required:false
 *    TeacherId Desc:老师Id Required:false
 *    AssistantId Desc:助教Id Required:false
 *    OrgSiteId Desc:助教Id Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    IsDeducted Desc:是否为课消，导出时使用（true:课消，false:授课课时） Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsDeductedDetailPaging (body) {
  return request(baseUrl + '/getStatisticsDeductedDetailPaging', {
    method: 'POST',
    body: body
  });
}

//  课程授课 预约明细

async function _getStatisticsClassBookingCount (body) {
  return request(baseUrl + '/GetStatisticsClassBookingCount', {
    method: 'POST',
    body: body
  });
}

//  课程授课-预约明细 导出
async function _getStatisticsClassBookingCountExport (body) {
  return request(baseUrl + '/GetStatisticsClassBookingCountExport', {
    method: 'POST',
    body: body
  });
}
//   课程授课-按学员 分页查询
async function _getStatisticsClassStudentPaging (body) {
  return request(baseUrl + '/GetStatisticsClassStudentPaging', {
    method: 'POST',
    body: body
  });
}
//  课程授课-按学员 导出
async function _getStatisticsClassStudentExport (body) {
  return request(baseUrl + '/GetStatisticsClassStudentExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区剩余学费统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForBranch (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区剩余学费统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForBranchExport (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程剩余学费统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForCourse (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForCourse', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程剩余学费统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForCourseExport (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForCourseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型剩余学费统计查询
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForCourseType (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForCourseType', {
    method: 'POST',
    body: body
  });
}

/**
 * 课程类型剩余学费统计导出
 * @param {*} body
 * {
 *    ShowType Desc:True数量 False钱 Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftForCourseTypeExport (body) {
  return request(baseUrl + '/getStatisticsFeeLeftForCourseTypeExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 剩余学费明细查询
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftDetail (body) {
  return request(baseUrl + '/getStatisticsFeeLeftDetail', {
    method: 'POST',
    body: body
  });
}

/**
 * 剩余学费明细统计导出
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftDetailExport (body) {
  return request(baseUrl + '/getStatisticsFeeLeftDetailExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 剩余学费明细分页查询
 * @param {*} body
 * {
 *    CourseId Desc:所属课程ID Required:false
 *    CourseType Desc:课程类型Id 字典表 CourseType Required:false
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsFeeLeftDetailPaging (body) {
  return request(baseUrl + '/getStatisticsFeeLeftDetailPaging', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区实收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForBranch (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区实收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForBranchExport (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForBranchExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 经办人实收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForUser (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForUser', {
    method: 'POST',
    body: body
  });
}

/**
 * 经办人实收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForUserExport (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForUserExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 支付方式实收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForPaySense (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForPaySense', {
    method: 'POST',
    body: body
  });
}

/**
 * 支付方式实收统计导出
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsRealIncomeForPaySenseExport (body) {
  return request(baseUrl + '/getStatisticsRealIncomeForPaySenseExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 校区应收统计查询
 * @param {*} body
 * {
 *    BranchId Desc:校区 空列表 则机构下 全部校区 Required:true
 *    OrgId Desc:机构Id Required:false
 *    StartDate Desc:开始日期 Required:true
 *    EndDate Desc:结束日期 Required:true
 *    EndDateStr Desc:结束日期 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStatisticsShouldForBranch (body) {
  return request(baseUrl + '/getStatisticsShouldForBranch', {
    method: 'POST',
    body: body
  });
}

/**
 * 客户来源详情 校区
 * @param {*} body
 */
async function _getStatisticsSourceForBranch (body) {
  return request(baseUrl + '/getStatisticsSourceForBranch', {
    method: 'POST',
    body: body
  });
}
/**
 * 客户来源详情 校区导出
 * @param {*} body
 */
async function _GetStatisticsSourceForBranchExp (body) {
  return request(baseUrl + '/GetStatisticsSourceForBranchExp', {
    method: 'POST',
    body: body
  });
}
/**
 * 客户来源详情 跟进人
 * @param {*} body
 */
async function _GetStatisticsSourceForUser (body) {
  return request(baseUrl + '/GetStatisticsSourceForUser', {
    method: 'POST',
    body: body
  });
}
/**
 * 客户来源详情 跟进人导出
 * @param {*} body
 */
async function _GetStatisticsSourceForUserExp (body) {
  return request(baseUrl + '/GetStatisticsSourceForUserExp', {
    method: 'POST',
    body: body
  });
}

/**
 * 过期收入明细列表
 * @param {*} body
 */
async function _GetStatisticsAutoExpiredDetail (body) {
  return request(baseUrl + '/GetStatisticsAutoExpiredDetail', {
    method: 'POST',
    body: body
  });
}

/**
 * 过期收入明细列表导出
 * @param {*} body
 */
async function _GetStatisticsAutoExpiredDetailExport (body) {
  return request(baseUrl + '/GetStatisticsAutoExpiredDetailExport', {
    method: 'POST',
    body: body
  });
}

/**
 * 手动收入明细列表
 * @param {*} body
 */
async function _GetStatisticAdjustDeductDetail (body) {
  return request(baseUrl + '/GetStatisticAdjustDeductDetail', {
    method: 'POST',
    body: body
  });
}

/**
 * 手动收入明细列表导出
 * @param {*} body
 */
async function _GetStatisticAdjustDeductDetailExport (body) {
  return request(baseUrl + '/GetStatisticAdjustDeductDetailExport', {
    method: 'POST',
    body: body
  });
}

async function _getStatisticsTimeCourseDetail (body) {
  return request(baseUrl + '/GetStatisticsTimeCourseDetail', {
    method: 'POST',
    body: body
  });
}
async function _getStatisticsTimeCourseDetailExport (body) {
  return request(baseUrl + '/GetStatisticsTimeCourseDetailExport', {
    method: 'POST',
    body: body
  });
}

async function _getStatisticsAllCourseDetail (body) {
  return request(baseUrl + '/GetStatisticsAllCourseDetail', {
    method: 'POST',
    body: body
  });
}
async function _getStatisticsAllCourseDetailExport (body) {
  return request(baseUrl + '/GetStatisticsAllCourseDetailExport', {
    method: 'POST',
    body: body
  });
}

async function _getStatisticsStudentApplyLeave (body) {
  return request(baseUrl + '/GetStatisticsStudentApplyLeave', {
    method: 'POST',
    body: body
  });
}

async function _getStatisticsStudentApplyLeaveExport (body) {
  return request(baseUrl + '/GetStatisticsStudentApplyLeaveExport', {
    method: 'POST',
    body: body
  });
}

export default {
  _getStatisticsStudentApplyLeave,
  _getStatisticsStudentApplyLeaveExport,
  _getStatisticsShouldForBranchExport,
  _getStatisticsShouldForUser,
  _getStatisticsShouldForUserExport,
  _getStatisticsShouldForPaySense,
  _getStatisticsShouldForPaySenseExport,
  _getStatisticsShouldForCourse,
  _getStatisticsShouldForCourseExport,
  _getStatisticsShouldForCourseType,
  _getStatisticsShouldForCourseTypeExport,
  _getStatisticsInsuranceCount,
  _getStatisticsRealIncomeAmount,
  _getStatisticsDeductPrice,
  _getTotalForHomePage,
  _getStatisticsSalesForBranch,
  _getStatisticsSalesForSeller,
  _getStatisticsSalesForCustomerAdded,
  _getStatisticsSalesForSalesFunnel,
  _getStatisticsSalesFunnelDetailForBranch,
  _getStatisticsSalesFunnelDetailForBranchExport,
  _getStatisticsSalesFunnelDetailForFollowUp,
  _getStatisticsSalesFunnelDetailForFollowUpExport,
  _getStatisticsSalesEntryChannelBranch,
  _getStatisticsSalesEntryChannelGender,
  _getStatisticsSalesProportionDetailForFollowUp,
  _getStatisticsSalesProportionDetailForFollowUpExport,
  _getStatisticsSalesProportionDetailForBranch,
  _getStatisticsSalesProportionDetailForBranchExport,
  _getStatisticsSalesGenderDetailForBranch,
  _getStatisticsSalesGenderDetailForBranchExport,
  _getStatisticsSalesGenderDetailForFollowUp,
  _getStatisticsSalesGenderDetailForFollowUpExport,
  _getStatisticsSalesForOrder,
  _getStatisticsSalesOrderDetailForAmountA,
  _getStatisticsSalesOrderDetailForALL,
  _getStatisticsSalesOrderDetailForAmountB,
  _getStatisticsSalesOrderDetailExport,
  _getStatisticsSalesOrderDetailForAmountBranchA,
  _getStatisticsSalesOrderDetailForAmountBranchB,
  _getStatisticsSalesOrderDetailForAmountBranchBExport,
  _getStatisticsClassCount,
  _getStatisticsClassCountForBranch,
  _getStatisticsClassCountForBranchExport,
  _getStatisticsClassCountForCourse,
  _getStatisticsClassCountForCourseExport,
  _getStatisticsClassCountForCourseType,
  _getStatisticsClassCountForCourseTypeExport,
  _getStatisticsClassCountForTeacherShare,
  _getStatisticsClassCountForTeacherShareExport,
  _getStatisticsClassCountForTeacherDeuce,
  _getStatisticsClassCountForTeacherDeuceExport,
  _getStatisticsStudentAttendance,
  _getStatisticsStudentAttendanceForBranch,
  _getStatisticsStudentAttendanceForBranchExport,
  _getStatisticsStudentAttendanceForTeacher,
  _getStatisticsStudentAttendanceForTeacherExport,
  _getStatisticsStudentAttendanceForCourse,
  _getStatisticsStudentAttendanceForCourseExport,
  _getStatisticsStudentAttendanceForCourseType,
  _getStatisticsStudentAttendanceForCourseTypeExport,
  _getStatisticsTeacherAttendance,
  _getStatisticsTeacherAttendanceForBranch,
  _getStatisticsTeacherAttendanceForBranchExport,
  _getStatisticsTeacherAttendanceForTeacher,
  _getStatisticsTeacherAttendanceForTeacherExport,
  _getStatisticsTeacherAttendanceForCourse,
  _getStatisticsTeacherAttendanceForCourseExport,
  _getStatisticsTeacherAttendanceForCourseType,
  _getStatisticsTeacherAttendanceForCourseTypeExport,
  _getStatisticsDeductedForBranch,
  _getStatisticsDeductedForBranchExport,
  _getStatisticsDeductedForCourse,
  _getStatisticsDeductedForCourseExport,
  _getStatisticsDeductedForCourseType,
  _getStatisticsDeductedForCourseTypeExport,
  _getStatisticsDeductedForTeachers,
  _getStatisticsDeductedForTeachersExport,
  _getStatisticsDeductedForAssistants,
  _getStatisticsDeductedForAssistantsExport,
  _getStatisticsDeductedForSite,
  _getStatisticsDeductedForSiteExport,
  _getStatisticsDeductedDetail,
  _getStatisticsDeductedDetailExport,
  _getStatisticsDeductedDetailPaging,
  _getStatisticsFeeLeftForBranch,
  _getStatisticsFeeLeftForBranchExport,
  _getStatisticsFeeLeftForCourse,
  _getStatisticsFeeLeftForCourseExport,
  _getStatisticsFeeLeftForCourseType,
  _getStatisticsFeeLeftForCourseTypeExport,
  _getStatisticsFeeLeftDetail,
  _getStatisticsFeeLeftDetailExport,
  _getStatisticsFeeLeftDetailPaging,
  _getStatisticsRealIncomeForBranch,
  _getStatisticsRealIncomeForBranchExport,
  _getStatisticsRealIncomeForUser,
  _getStatisticsRealIncomeForUserExport,
  _getStatisticsRealIncomeForPaySense,
  _getStatisticsRealIncomeForPaySenseExport,
  _getStatisticsShouldForBranch,
  _getStatisticsSourceForBranch,
  _GetStatisticsSourceForBranchExp,
  _GetStatisticsSourceForUser,
  _GetStatisticsSourceForUserExp,
  _GetStatisticsAutoExpiredDetail,
  _GetStatisticAdjustDeductDetail,
  _GetStatisticsAutoExpiredDetailExport,
  _GetStatisticAdjustDeductDetailExport,
  _getStatisticsClassBookingCount,
  _getStatisticsClassBookingCountExport,
  _getStatisticsClassStudentPaging,
  _getStatisticsClassStudentExport,
  _getStatisticsTimeCourseDetail,
  _getStatisticsTimeCourseDetailExport,
  _getStatisticsAllCourseDetail,
  _getStatisticsAllCourseDetailExport
}



// WEBPACK FOOTER //
// ./src/services/orgStatistics.js